// API for the order problems dashboard.
const jsonRequest = async (url, options) => {
  const res = await fetch(url, {
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    ...options,
  });
  const content = await res.json();
  if (!res.ok) throw new Error(content.error || "Request failed");
  return content;
};

// List of all problems (image payloads excluded — use fetchOrderProblem for those).
export const fetchOrderProblems = () => jsonRequest("/api/delivery/problems");

export const fetchOrderProblem = (id) =>
  jsonRequest(`/api/delivery/problems/${encodeURIComponent(id)}`);

export const updateOrderProblemStatus = (id, status, updatedBy) =>
  jsonRequest(`/api/delivery/problems/${encodeURIComponent(id)}/status`, {
    method: "PUT",
    body: JSON.stringify({ status, updatedBy }),
  });

// Live Webtrack order status for an problem's order number (proxied server-side).
export const fetchOrderInfo = (orderNumber) =>
  jsonRequest(
    `/api/delivery/problems/orderinfo/${encodeURIComponent(orderNumber)}`
  );

// Who to show as the reporter. Web-form submissions are anonymous (the server
// stores `anonymous: true` and no reporter fields), driver-app reports still
// carry a name. Older web submissions predate the anonymous switch and keep
// the name they were filed under.
export const reporterLabel = (problem) => {
  if (problem?.anonymous) return "Anonymous";
  return problem?.reporterName || "Unknown";
};

export const addOrderProblemNote = (id, text, author) =>
  jsonRequest(`/api/delivery/problems/${encodeURIComponent(id)}/notes`, {
    method: "POST",
    body: JSON.stringify({ text, author }),
  });
